import { fetcher } from "helpers/fetcher";

import {
  TGetCompanyMatchingFilterDataReq,
  TGetCompanyMatchingFilterDataRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCompanyMatchingFilterData = async (
  params?: TGetCompanyMatchingFilterDataReq
) => {
  return await fetcher<
    TGetCompanyMatchingFilterDataRes,
    TGetCompanyMatchingFilterDataReq["data"]
  >(ENDPOINT.BU.GET_COMPANY_MATCHING_FILTER, {
    data: params?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.GET_COMPANY_MATCHING_FILTER.version,
      [API_HEADER.BU_ID]: params?.idBu,
    },
  });
};

export const queryGetCompanyMatchingFilterData = async (
  params?: TGetCompanyMatchingFilterDataReq
) => {
  return (await getCompanyMatchingFilterData(params)).data;
};

queryGetCompanyMatchingFilterData._key = (
  params?: TGetCompanyMatchingFilterDataReq,
  key?: string
) => [ENDPOINT.BU.GET_COMPANY_MATCHING_FILTER.url, params, key];
